import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { from, Observable } from 'rxjs';
import { ProductService } from "../services/api/product/product.service";

@Injectable({
  providedIn: 'root'
})
export class PricePeriodResolver implements Resolve<boolean> {
  constructor(private productService: ProductService) {
    // constructor
  }

  resolve(): Observable<any> {
    return from(this.productService.getPricePeriods().toPromise());
  }
}
